import { Component, Input, OnInit } from '@angular/core';
import { PrinterSettings, PrinterSettingsData } from '../../../../@core/interfaces/masters/printersettings';
import { imageatch_detData } from '../../../../@core/interfaces/masters/imageatch_det';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'ngx-bed-dashboard-ward-bed-print',
  templateUrl: './bed-dashboard-ward-bed-print.component.html',
  styleUrls: ['./bed-dashboard-ward-bed-print.component.scss']
})
export class BedDashboardWardBedPrintComponent implements OnInit {

  @Input() wardData:any[];
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  p: number = 1;
  protected readonly unsubscribe$ = new Subject<void>();
  @Input() title1:string= "Current Ward Bed Availability";
  message: string = "No data Found";

  styleUrl="/assets/css/print.css,/assets/css/a4portrait.css";
  srcname="../.././../../assets/images/white.png";
  psDetails:PrinterSettings;
  fromDate: Date = new Date();
  constructor(private iatchSrvc: imageatch_detData,protected psSrvc:PrinterSettingsData) { }


  ngOnInit(): void {
    this.loadPSF();
    this.loadImg();
  }

  loadPSF()
  {
    // call api load printer settings
    this.psSrvc.list(this.tenantId +"/"+this.branchId+ "/printersettings").pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

      var ps=data.filter(ps=>ps.pageSetupFor==="List Pages A4 Portrait")
      // set printer settings data
      if(ps.length>0){
        this.psDetails=ps[0];
      // dynamic set style url based on papper size
            this.styleUrl="/assets/css/print.css,/assets/css/"+(this.psDetails.paperSize).toLowerCase()+(this.psDetails.orientation).toLowerCase()+".css";
      // set position header and footer start
          this.psDetails.topHeaderLogoPosition="center "+this.psDetails.topHeaderLogoPosition;
          this.psDetails.topHeaderPosition="center "+this.psDetails.topHeaderPosition;
          this.psDetails.reportHeaderPlacement="center "+this.psDetails.reportHeaderPlacement;
          this.psDetails.topHeaderLogoRequired=this.psDetails.topHeaderLogoRequired =="1" ? true : false;
          this.psDetails.topHeaderRequired=this.psDetails.topHeaderRequired =="1" ? true : false;
          this.psDetails.bottomFooterLogoPosition="center "+this.psDetails.bottomFooterLogoPosition;
          this.psDetails.bottomFooterPosition="center "+this.psDetails.bottomFooterPosition;
          this.psDetails.bottomFooterLogoRequired=this.psDetails.bottomFooterLogoRequired =="1" ? true : false;
          this.psDetails.bottomFooterRequired=this.psDetails.bottomFooterRequired =="1" ? true : false;
          // end
      }else{
        this.styleUrl="/assets/css/print.css,/assets/css/a4portrait.css";
        
      }
      }, (error) => {
      }, () => {


      });

  }

  loadImg(){

      this.iatchSrvc.getById(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/logo`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.srcname="../.././../../assets/images/userav.png"
        this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/download`,data[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
          this.srcname = 'data:image/jpeg;base64,' + downloaddata;
        }, (error) => {

        }, () => {

        });

    }, (error) => {

    }, () => {

    });

    }

    totalAvailableOccupiedStatus(type:string):number {
      if (this.wardData.length > 0) {
        return this.wardData.map(t => t[type]).reduce((a, value) => a + value, 0);
      }
      return 0;
    }

}
